<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="320"
    bottom
    left
    offset-y
    content-class="admin-profile-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="profile-trigger"
        :class="{ 'profile-trigger--active': menu }"
        aria-label="Open profile and appearance menu"
        icon
        large
      >
        <span class="profile-trigger__avatar-wrap">
          <v-avatar size="38" class="profile-trigger__avatar">
            <v-img :src="getImage" alt="User profile"></v-img>
          </v-avatar>
          <span v-if="isAdmin" class="profile-trigger__role">
            <v-icon>mdi-crown</v-icon>
          </span>
        </span>
      </v-btn>
    </template>

    <v-card class="profile-menu-card">
      <div class="profile-menu-header">
        <v-avatar size="54" class="profile-menu-avatar">
          <v-img :src="getImage" alt="Employee profile"></v-img>
        </v-avatar>
        <div class="profile-menu-identity">
          <small>Signed in as</small>
          <strong>{{
            employee && employee.name ? employee.name : "Administrator"
          }}</strong>
          <span>{{ employeeRole }}</span>
        </div>
        <v-btn
          icon
          class="profile-edit-button"
          aria-label="Edit profile"
          @click="moveToProfile"
        >
          <v-icon small>mdi-pencil-outline</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>

      <div class="appearance-control">
        <span class="appearance-control__icon">
          <v-icon>{{ darkTheme ? "mdi-weather-night" : "mdi-white-balance-sunny" }}</v-icon>
        </span>
        <div class="appearance-control__copy">
          <strong>Dark theme</strong>
          <small>{{ darkTheme ? "On" : "Off — using light theme" }}</small>
        </div>
        <v-switch
          v-model="darkTheme"
          color="accent"
          inset
          hide-details
          aria-label="Use dark theme"
        ></v-switch>
      </div>

      <v-divider></v-divider>

      <v-list class="profile-menu-actions">
        <v-list-item
          v-if="
            employeeAccess.setting &&
            employeeAccess.setting.switchLocation
          "
          to="/login/location"
        >
          <v-list-item-icon>
            <v-icon>mdi-map-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Switch location</v-list-item-title>
            <v-list-item-subtitle>
              Manage a different workplace
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon small>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-list-item
          v-if="employeeAccess.setting && employeeAccess.setting.account"
          to="/backoffice"
        >
          <v-list-item-icon>
            <v-icon>mdi-shield-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Account settings</v-list-item-title>
            <v-list-item-subtitle>
              Organization and subscription
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon small>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <div class="profile-menu-footer">
        <v-btn text block class="logout-button" to="/logout">
          <v-icon left small>mdi-logout</v-icon>
          Sign out
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import UserImg from "@/assets/images/user.jpeg";
import { mapGetters } from "vuex";
import { saveTheme } from "@/utils/theme";

export default {
  name: "app-menu-bar",
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    moveToProfile() {
      console.log("lastEmployee", this.employee);
      if (this.employee && this.employee.id) {
        const id = this.employee.id;
        return this.$router.push({ name: "employee-edit", params: { id: id } });
      }
      return false;
    },
  },
  created() {
    console.log('employee', this.employee)
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
    darkTheme: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(value) {
        this.$vuetify.theme.dark = value;
        saveTheme(value ? "dark" : "light");
      },
    },
    isAdmin() {
      return Boolean(
        this.employee &&
          (this.employee.owner ||
            (this.employee.metadata &&
              this.employee.metadata.timeClockLogin &&
              this.employee.metadata.timeClockLogin.admin))
      );
    },
    employeeRole() {
      return this.employee && this.employee.owner
        ? "Organization owner"
        : "Administrator";
    },
    getImage() {
      if (this.employee && this.employee.imageURL) {
        return this.employee.imageURL;
      } else return UserImg;
    },
  },
};
</script>

<style scoped>
.profile-trigger {
  position: relative;
  width: 50px !important;
  height: 50px !important;
  flex: 0 0 50px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

.profile-trigger--active {
  border-color: rgba(34, 211, 238, 0.4);
  background: rgba(34, 211, 238, 0.1);
}

.profile-trigger__avatar {
  border: 2px solid rgba(96, 165, 250, 0.35);
}

.profile-trigger__avatar-wrap {
  position: relative;
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
}

.profile-trigger__role {
  position: absolute;
  right: 1px;
  bottom: 1px;
  display: grid;
  width: 16px;
  height: 16px;
  place-items: center;
  border: 2px solid var(--v-surface-base);
  border-radius: 50%;
  background: #fbbf24;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.profile-trigger__role .v-icon {
  color: #422006 !important;
  font-size: 10px !important;
}

@media (max-width: 600px) {
  .profile-trigger {
    width: 46px !important;
    height: 46px !important;
    flex-basis: 46px;
    border-color: transparent;
    background: transparent;
  }

  .profile-trigger__avatar {
    border-width: 2px;
  }

  .profile-trigger__role {
    right: 1px;
    bottom: 1px;
    width: 14px;
    height: 14px;
    border-width: 1px;
  }

  .profile-trigger__role .v-icon {
    font-size: 9px !important;
  }
}

.profile-menu-card {
  border-radius: 18px !important;
  background: var(--v-surface-base) !important;
}

.profile-menu-header {
  display: flex;
  padding: 18px;
  align-items: center;
  gap: 13px;
}

.profile-menu-avatar {
  border: 2px solid rgba(96, 165, 250, 0.3);
}

.profile-menu-identity {
  min-width: 0;
}

.profile-menu-identity small,
.profile-menu-identity strong,
.profile-menu-identity span {
  display: block;
}

.profile-menu-identity small {
  color: #7f91a9;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.profile-menu-identity strong {
  overflow: hidden;
  margin-top: 2px;
  color: var(--v-theme-text, inherit);
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-menu-identity span {
  margin-top: 2px;
  color: #60a5fa;
  font-size: 11px;
  font-weight: 650;
}

.profile-edit-button {
  margin-left: auto;
  border: 1px solid rgba(148, 163, 184, 0.16);
  color: #94a3b8 !important;
}

.appearance-control {
  display: flex;
  min-height: 78px;
  padding: 14px 18px;
  align-items: center;
  gap: 12px;
}

.appearance-control__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 12px;
  background: rgba(34, 211, 238, 0.1);
}

.appearance-control__icon .v-icon {
  color: var(--v-accent-base) !important;
}

.appearance-control__copy {
  flex: 1;
}

.appearance-control__copy strong,
.appearance-control__copy small {
  display: block;
}

.appearance-control__copy strong {
  font-size: 14px;
}

.appearance-control__copy small {
  margin-top: 2px;
  color: #7f91a9;
  font-size: 11px;
}

.profile-menu-actions {
  padding: 8px !important;
  background: transparent !important;
}

.profile-menu-actions .v-list-item {
  min-height: 68px;
  margin: 3px 0;
  border-radius: 12px;
}

.profile-menu-actions .v-list-item:hover {
  background: rgba(96, 165, 250, 0.08) !important;
}

.profile-menu-actions .v-list-item__icon {
  margin-right: 14px !important;
}

.profile-menu-actions .v-list-item__icon .v-icon {
  color: #60a5fa !important;
}

.profile-menu-actions .v-list-item__title {
  font-size: 13px;
  font-weight: 700;
}

.profile-menu-actions .v-list-item__subtitle {
  margin-top: 2px;
  font-size: 10px;
}

.profile-menu-footer {
  padding: 9px;
  border-top: 1px solid rgba(148, 163, 184, 0.13);
}

.logout-button {
  color: var(--v-error-base) !important;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
</style>

<style>
.admin-profile-menu {
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 18px !important;
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.4) !important;
}
</style>
